import React from "react"
import { makeStyles } from "@mui/styles";
import CloseIcon from '@mui/icons-material/Close';
import { CartItem } from "../../models/cart/cart";
import { Box } from "@mui/material";
import { COLORS } from "../../constants/colors";

export const CartItemComponent = (props) => {
    const { item, redirect, onRemove, discountCampaign } = props
    const classes = useStyles();
    const campaign = discountCampaign?.campaign

    const onRedirect = (item: CartItem) => {
        if (["e_gift_card_001", "gift_card_001"].indexOf(item.sku) < 0) {
            redirect(`/product/${item.product.id}`)
        }
    }
    return <li
        className={classes.listItem}>
        <div style={{ flexDirection: 'row', display: 'flex', paddingTop: 20 }}>
            
            <div style={{ flexDirection: 'column', width: '17%', cursor: 'pointer' }} onClick={()=> onRedirect(item)}>
                <img src={item.product.mainImage} style={{ width: 30 }} />
            </div>
            <Box sx={{ 
                '&:hover': {
                    textDecoration: 'underline'
                },
                flexDirection: 'column', width: '55%', cursor: 'pointer', display: 'flex' }} onClick={()=> onRedirect(item)}>
                <span style={{fontWeight: 'bold'}}>{item.product.brand.title}</span>
                <span>{item.product.name}</span>
                {campaign && <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4, marginTop: 4, paddingRight: 4 }}>
                    <span style={{ color: COLORS.RED, overflowWrap: 'anywhere' }}>{campaign.name}</span>
                    <span style={{ backgroundColor: COLORS.RED, color: 'white', borderRadius: 4, padding: '2px 5px', fontSize: 11, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                        -{campaign.value}{campaign.type === 'percentage' ? '%' : '₾'}
                    </span>
                </div>}
            </Box>
            <div style={{ flexDirection: 'column', width: '5%', cursor: 'pointer' }} onClick={()=> onRedirect(item)}>
                <span>{item.quantity}</span>
            </div>
            <div style={{ flexDirection: 'column', width: '20%', textAlign: 'right', position: 'relative', cursor: 'pointer' }}>
                <span>{item?.specialPrice && item.specialPrice * item.quantity}</span> ₾
                <div style={{}} onClick={()=> {
                    onRemove(item)
                }}>
                    <CloseIcon />
                </div>
            </div>
        </div>
    </li>
}


const useStyles = makeStyles({
    listItem: { color: 'black', fontFamily: 'FiraGo', fontSize: 12, fontWeight: '300' }

});
